import ModalCustom from "./modal-template-default";
import Button from "../Button";
import PaymentDetails from "../PaymentDetails";
import useFormat from "../../hooks/utils/useFormat";

/**
 * Para onde a parcela foi paga de fato — registrado na baixa, e não o que o
 * título combinou (o gestor pode ter trocado o método na hora, ou o fornecedor
 * pode ter mudado de banco depois da criação do título).
 */
const ModalBillToPayPaidDetails = props => {
  const { show, onHide, bill } = props;
  const { formatDate, formatReal } = useFormat();

  return (
    <ModalCustom show={show} onHide={onHide} id="bill_to_pay_paid_details_container">
      <ModalCustom.Header>
        <ModalCustom.Title>Dados do Pagamento</ModalCustom.Title>
      </ModalCustom.Header>
      <ModalCustom.Body>
        <p className="small-label mb-0">
          <b>Parcela:</b> {bill?.quotas}
          <br />
          <b>Pago em:</b> {bill?.payment_date ? formatDate(bill.payment_date, 7) : "-"}
          {!!bill?.userPaid?.username && ` por ${bill.userPaid.username}`}
          <br />
          <b>Valor pago:</b> {formatReal(bill?.value_paid || 0)}
        </p>
        <PaymentDetails payment={bill} className="mt-3" />
      </ModalCustom.Body>
      <ModalCustom.Footer>
        <Button color="primary_ghost" onClick={onHide}>
          Fechar
        </Button>
      </ModalCustom.Footer>
    </ModalCustom>
  );
};

export default ModalBillToPayPaidDetails;
